import { apiSettings } from './ApiSettings';

const { uri, credentials } = apiSettings;

export const getTokenSii = async () => {
    const URL = `${uri}solicitarToken`;

    try {
        const res = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(credentials)
        })
    
        if(res.ok) {
            const data = await res.json();
            return data.token;
        }
    }catch (error) {
        return false;
    }
}